import axios from "axios";

const apiClient = axios.create({
	baseURL:
		process.env.NODE_ENV === "production"
			? "https://backend.mnediliziaristrutturazione.com"
			: "http://localhost:3001",
});

export default apiClient;
